import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`Assuming 2T Cait (-15), Ravus Manor worst battle and ambush, and Quarrycrest ambush (-5) you are short 13JP for Leghold. You can still win without it, but you're limited to 6T scripts as 9T require Leghold, and you lose some options for 6T.`}<br parentName="p"></br>{`
`}{`Will note backups. Generally, if you 1T kill Cait you don't have to worry.`}</p>
    </blockquote>
    <SEO title="Octopath Traveler Olberic Single Story 3 Character Cait route" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Iron Sword`}</strong>{` + `}<strong parentName="p">{`War Spear`}</strong><br parentName="p"></br>{`
`}{`Challenge two dudes: Spear, Spearx2`}<br parentName="p"></br>{`
`}{`Sword on 2 break guy -> Level Slash -> Level Slash x4`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Fire S`}</strong>{` if no Wind S drop earlier.`}<br parentName="p"></br>{`
`}{`Heal to full before Gaston`}</p>
    <h4 {...{
      "id": "gaston"
    }}>{`Gaston`}</h4>
    <ol>
      <li parentName="ol">{`Level Slash`}</li>
      <li parentName="ol">{`Fire/Wind Soulstone`}</li>
      <li parentName="ol">{`Light Soulstone`}</li>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`4xSpear`}</li>
      <li parentName="ol">{`3xSpear`}</li>
      <li parentName="ol">{`Heal`}</li>
      <li parentName="ol">{`Spear`}</li>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`4xSpear`}</li>
      <li parentName="ol">{`Spear`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <p>{`Thousand Spears`}</p>
    </Menu>
    <p>{`Go to Scholar Shrine, kill Cait on the way.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <p><strong parentName="p">{`Scholar`}</strong>{`, Blizzard + Lightning Blast`}</p>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <p>{`Evasive Maneuvers`}</p>
    </Menu>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700
    }}>GO TO PURGATION</strong>
    <p>{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Bolderfall`}</strong>{`. Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{` + `}<strong parentName="p">{`Olive L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Enter `}<strong parentName="p">{`Victor's Hollow`}</strong>{`, start Ch.2, TP `}<strong parentName="p">{`Rippletide`}</strong>{` when back on 1st screen.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <p>{`Light L`}</p>
    <p>{`Head towards `}<strong parentName="p">{`Merchant Shrine`}</strong>{`. Pick `}<strong parentName="p">{`Light S`}</strong>{` `}<em parentName="p">{`if you want to kill Ravus Manor battle`}</em>{`, `}<strong parentName="p">{`$1200`}</strong>{`. Get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Cobblestone`}</strong>{`, go to Runeblade. Pick `}<strong parentName="p">{`Light M`}</strong>{`, `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`$50000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`. Go to `}<strong parentName="p">{`Wellspring`}</strong>{`, pick `}<strong parentName="p">{`Fire L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`Kill Ravus Manor battle w/ Light S + Level Slash x2, or run if no Light S.`}</p>
    <p>{`Heathecote: Fire L + Light M`}</p>
    <p>{`Go to Shop, buy 1 `}<strong parentName="p">{`Herb of Valor`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Head towards `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get a battle on Bolderfall screen, you can M Stone to kill it.`}<br parentName="p"></br>{`
`}{`You then run from Cervantes, get the Silver-filled Pouch in Riverford, and sell it in Marsalim (closest shop).`}<br parentName="p"></br>{`
`}{`End result is -2k, -10s compared to just getting the flee (roughly same as 2nd turn flee). If you 1T Cait killed, you guarantee Leghold JP even with Ravus Manor battle skip and Quarrycrest ambush.`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Pom S`}</strong>{`, `}<strong parentName="p">{`need`}</strong>{` to kill Quarrycrest battle, use Light L.`}<br parentName="p"></br>{`
`}{`Challenge Cervantes and kill w/ M Stone.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Need 207EXP to level off 1st Challenge`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Riverford`}</strong>{`. Go to towards `}<strong parentName="p">{`Refuge Ruins`}</strong>{` and pick `}<strong parentName="p">{`Wind L`}</strong>{` along the way.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Forbidden Blade`}</strong>{`, `}<strong parentName="p">{`Enchanted Rod`}</strong>{`, `}<strong parentName="p">{`Force Shield`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`. Go to `}<strong parentName="p">{`Marsalim Catacombs`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Rev Jam`}</strong>{`, `}<strong parentName="p">{`Master Spear`}</strong>{`, `}<strong parentName="p">{`Viper Dagger`}</strong>{` (in that order) and exit.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Marsalim`}</strong>{`. Buy `}<strong parentName="p">{`2 Pom L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Tempest Amulet`}</strong>{`, buy `}<strong parentName="p">{`3 L Stones`}</strong>{`, pick `}<strong parentName="p">{`3 chests`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`, continue Olberic Ch.2.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Optimize`}</li>
        <li parentName="ul">{`Therion: Viper Dagger`}</li>
      </ul>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Plum Olberic`}</li>
        <li parentName="ul"><em parentName="li">{`If Olberic will level off first Challenge, you can skip this.`}</em></li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Warrior`}</strong>{`, `}<strong style={{
            color: 'red'
          }}>{`Cross Strike`}</strong>{`, `}<strong parentName="li">{`Scholar`}</strong></li>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive, `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Cover`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "olberic-ch2"
    }}>{`Olberic Ch.2`}</h3>
    <h4 {...{
      "id": "right-challenge"
    }}>{`Right Challenge`}</h4>
    <ol>
      <li parentName="ol">{`Sword`}</li>
      <li parentName="ol">{`Sword`}</li>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`Sword x2`}</li>
      <li parentName="ol">{`Cross Strike x4`}</li>
    </ol>
    <h4 {...{
      "id": "left-challenge"
    }}>{`Left Challenge`}</h4>
    <ol>
      <li parentName="ol">{`Abide`}</li>
      <li parentName="ol">{`Thousand Spears`}</li>
      <li parentName="ol">{`Thousand Spears x4 / Cross Strike x4 if broken.`}</li>
    </ol>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700,
      lineHeight: '72px'
    }}>DONT FORGET TO PURCHASE</strong>
    <p>{`Buy `}<strong parentName="p">{`2 Shadow M`}</strong>{` and `}<strong parentName="p">{`Bottle of Blinding Dust`}</strong>{`.`}</p>
    <h4 {...{
      "id": "victorino---12718---sword-dagger-wind-dark"
    }}>{`Victorino - 12718 - Sword, Dagger, Wind, Dark`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Abide`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: HHM x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHM x3`}</li>
      <li parentName="ul">{`Olberic: Thunder L`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Cross Strike x4`}</li>
      <li parentName="ul">{`Therion: Attack x2`}</li>
    </ul>
    <h4 {...{
      "id": "joshua---18184---axe-staff-fire-light---ice-m-30-x2"
    }}>{`Joshua - 18184 - Axe, Staff, Fire, Light - Ice M 30% x2`}</h4>
    <blockquote>
      <p parentName="blockquote">{`You can make the fight safer by paying attention to turn order.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Defend x2 / Defend / Pom S T2 Merchant 2`}</li>
      <li parentName="ul">{`Merchant 1: HHM / Pom M Olberic`}</li>
      <li parentName="ul">{`Merchant 2: Defend / Pom S T2 Merchant 2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: HHB x3`}</li>
      <li parentName="ul">{`Olberic: Staff x3 `}{`[L]`}</li>
      <li parentName="ul">{`Merchant 2: HHV x3/4 / Defend`}</li>
      <li parentName="ul"><em parentName="li">{`HHV early safer because you kill the adds. HHVx3 requires another M Stone`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`HHV x4 / M Stone`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Watch for M Stone drop, this affects stones bought in Riverford`}<br parentName="p"></br>{`
`}{`You really want 1, 51% chance of at least 1.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep + Hired Help, `}<strong parentName="li">{`Scholar`}</strong></li>
        <li parentName="ul">{`Tressa: Sidestep, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold + Thunderbird`}</li>
        <li parentName="ul">{`Therion: `}<strong style={{
            color: 'red'
          }}>{`Steal SP`}</strong>{`, `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Enchanted Rod`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: EI`}</li>
        <li parentName="ul">{`Tressa: EI + Heightened Senses`}</li>
        <li parentName="ul">{`Therion: EI`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Therion will be missing some HP from job change here. It's a good thing!`}<br parentName="p"></br>{`
`}{`He gets put into Cover range from Crushing Blow. If he's full HP he doesn't.`}</p>
      </blockquote>
    </Menu>
    <h4 {...{
      "id": "archibold---20182---dagger-bow-ice-dark"
    }}>{`Archibold - 20182 - Dagger, Bow, Ice, Dark`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Throw Shadow L before Fire L`}<br parentName="p"></br>{`
`}{`If you don't have a Merchant before Archibold, you can YOLO Bottle of Blinding Dust and pray.`}<br parentName="p"></br>{`
`}{`With pattern of Merchant Olberic Add Archibold Merchant, you can try Olberic Defend x2. Best way to fill range is to replace Shadow M with a L Stone. If Tressa is before Archibold T3, you can have her Pom S Olberic T2 but fight is a range.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: HHM`}</li>
      <li parentName="ul">{`Others: Shadow L + Fire L`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Blizzard`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Steal SP`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Abide`}</li>
      <li parentName="ul">{`Tressa: Bow x2`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Cross Strike x4`}</li>
      <li parentName="ul">{`Tressa: Shadow M`}</li>
      <li parentName="ul">{`Therion: Steal SP x4`}</li>
    </ul>
    <h4 {...{
      "id": "gustav---39549---spear-axe-bow-fire-dark"
    }}>{`Gustav - 39549 - Spear, Axe, Bow, Fire, Dark`}</h4>
    <p>{`3T Strat (requires Therion 1st)`}<br parentName="p"></br>{`
`}{`T1: HHVx2, Thousand Spears, Leghold`}<br parentName="p"></br>{`
`}{`T2: Thousand Spears, Rain of Arrows, Armor Corrosive`}<br parentName="p"></br>{`
`}{`T3: Tressa HHVx4, Steal SPx2, X Strike x4`}</p>
    <blockquote>
      <p parentName="blockquote">{`If willing to YOLO, can skip Leghold T1 and tank Gustav's attacks.`}<br parentName="p"></br>{`
`}{`He always goes Level Slash > Attack T2, and X Strike > Level Slash T3`}<br parentName="p"></br>{`
`}{`You just need to pray Level Slash doesn't crit Tressa`}</p>
    </blockquote>
    <p>{`Listing 4T fight for bad turn orders.`}</p>
    <h5 {...{
      "id": "turn-1-not-sure-if-we-can-skip-leghold-here"
    }}>{`Turn 1 (Not sure if we can skip Leghold here)`}</h5>
    <blockquote>
      <p parentName="blockquote">{`If Tressa before Therion, can have them swap but fight might become 5T`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Olberic: Defend`}</li>
      <li parentName="ul">{`Therion: HHV x2`}</li>
      <li parentName="ul">{`Tressa: Leghold`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Defend x2`}</li>
      <li parentName="ul">{`Tressa: RoA`}</li>
      <li parentName="ul">{`Therion: HHM`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Thousand Spears`}</li>
      <li parentName="ul">{`Tressa: RoA`}</li>
      <li parentName="ul">{`Therion: Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Cross Strike x3`}</li>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
      <li parentName="ul">{`Therion: Steal SP x3`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`. Buy M Stones + Pom M as needed.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Pom M if we used 1 in Ch.2.`}<br parentName="p"></br>{`
`}{`We need 2M stones here, ideally 3 if no Ice M drop`}</p>
    </blockquote>
    <p>{`Go to `}<strong parentName="p">{`Warbringer`}</strong>{`. Pick `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`, finish chapter. TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch3"
    }}>{`Olberic Ch.3`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`JP Backups`}</strong><br parentName="p"></br>{`
`}{`15JP: Girl in front of town: TS, XS x3 (same as other challenge here)`}</p>
      <p parentName="blockquote">{`If you miss a 1T kill on Lizards (-12), don't backtrack, can fight in Riverford.`}</p>
    </blockquote>
    <p>{`Talk to first 2 NPCs, then Challenge 2nd NPC.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Challenge`}</strong>{`: Thousand Spears, Cross Strike x3 (Spear x3 if 4 his TS)`}</p>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700,
      lineHeight: '72px'
    }}>Pick $23000</strong>
    <h4 {...{
      "id": "lizards-1"
    }}>{`Lizards #1`}</h4>
    <p>{`L + M`}</p>
    <h4 {...{
      "id": "lizards-2"
    }}>{`Lizards #2`}</h4>
    <p>{`Ice L + M OR L + Ice M + Blizzard x2 OR L + M + Blizzard x2 if no Hold Strong OR L + 2M`}</p>
    <blockquote>
      <p parentName="blockquote">{`Reason you want an Ice M or an extra M is you can't kill with Blizzard if Hold Strong.`}<br parentName="p"></br>{`
`}{`And you need T1 kill for JP bonus.`}</p>
    </blockquote>
    <strong style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700,
      lineHeight: '72px'
    }}>Pick $6000</strong>
    <h4 {...{
      "id": "lizardman-chieftan---51868---sword-dagger-axe-lightning-light"
    }}>{`Lizardman Chieftan - 51868 - Sword, Dagger, Axe, Lightning, Light`}</h4>
    <blockquote>
      <p parentName="blockquote">{`There's room to get bonuses in this fight / save Pom L, but probably not worth bothering with`}<br parentName="p"></br>{`
`}{`Assuming EVERYTHING rolls min damage, he lives with 353`}</p>
    </blockquote>
    <h4 {...{
      "id": "t1"
    }}>{`T1`}</h4>
    <ul>
      <li parentName="ul">{`Olberic: Pom L Therion`}</li>
      <li parentName="ul">{`Tressa: Leghold`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
    </ul>
    <h4 {...{
      "id": "t2"
    }}>{`T2`}</h4>
    <ul>
      <li parentName="ul">{`Olberic: Lightning Blast`}</li>
      <li parentName="ul">{`Tressa: Thunderbird`}</li>
      <li parentName="ul">{`Therion: HHV x4`}</li>
    </ul>
    <h4 {...{
      "id": "t3"
    }}>{`T3`}</h4>
    <ul>
      <li parentName="ul">{`Olberic: Cross Strike x4`}</li>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
      <li parentName="ul">{`Therion: Steal SP x2`}</li>
    </ul>
    <p style={{
      color: 'red',
      fontSize: '72px',
      fontWeight: 700
    }}>DO THIS MENU</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong></li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Scholar`}</strong>{`, Lightning Blast`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "erhardt---14819---sword-axe-ice-dark"
    }}>{`Erhardt - 14819 - Sword, Axe, Ice, Dark`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Replace a Sword with HHM if you buff his attack`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack x3`}</li>
      <li parentName="ol">{`HHVx3`}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch4"
    }}>{`Olberic Ch.4`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`JP Backups`}</strong><br parentName="p"></br>{`
`}{`15JP: 2nd screen 1st guy guarding house: TS, XS x2 (same as wellspring)`}<br parentName="p"></br>{`
`}{`10/11JP: Cervantes right guy in front of Tavern: XS x2. Can miss the crit, which means you only get 10JP with a T2 kill. Can also just throw a M Stone if you have a extra.`}</p>
    </blockquote>
    <p>{`If you didn't buy 1 earlier, pick `}<strong parentName="p">{`Herb of Valor`}</strong>{` bottom left of second screen.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Ice L`}</strong>{` if needed.`}</p>
    <h4 {...{
      "id": "red-hat---24320---sword-axe-wind---thunder-m-80"
    }}>{`Red Hat - 24320 - Sword, Axe, Wind - Thunder M 80%`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Replace a Attack with HHM if you buff his attack`}</p>
    </blockquote>
    <p>{`2 Stone fight:`}<br parentName="p"></br>{`
`}{`1. Wind L`}<br parentName="p"></br>{`
`}{`2. Attack`}<br parentName="p"></br>{`
`}{`3. Attack`}<br parentName="p"></br>{`
`}{`4. HHVx4`}<br parentName="p"></br>{`
`}{`5. L Stone`}</p>
    <p>{`1 Stone fight:`}<br parentName="p"></br>{`
`}{`1. Abide`}<br parentName="p"></br>{`
`}{`2. Cross Strike x3`}<br parentName="p"></br>{`
`}{`3. Cross Strike`}<br parentName="p"></br>{`
`}{`4. Grape M`}<br parentName="p"></br>{`
`}{`5. Attack`}<br parentName="p"></br>{`
`}{`6. HHV x4`}<br parentName="p"></br>{`
`}{`7. L Stone`}</p>
    <blockquote>
      <p parentName="blockquote">{`If he didn't drop a Thunder M, consider buying it from the old lady at the start of screen 2.`}<br parentName="p"></br>{`
`}{`It's very helpful for 9T Werner.`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{` in Lord's Manse before warping back to `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Unequip All`}</li>
        <li parentName="ul">{`Therion: Remove Viper Dagger `}{`[1D]`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: 2 Skills, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Merchant`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Hang Tough`}</li>
      </ul>
    </Menu>
    <p>{`Go to shop, sell until $119000`}</p>
    <h4 {...{
      "id": "werner---101396---dagger-axe-lightning-wind-light"
    }}>{`Werner - 101396 - Dagger, Axe, Lightning, Wind, Light`}</h4>
    <h5 {...{
      "id": "vet-counts"
    }}>{`Vet counts`}</h5>
    <p>{`16 - M, M on weakness`}<br parentName="p"></br>{`
`}{`15 - L, M on weakness. Just L is range`}<br parentName="p"></br>{`
`}{`14 - L, M, M on weakness`}</p>
    <blockquote>
      <p parentName="blockquote">{`There's 3 main opens to consider. The one in notes is the default.`}<br parentName="p"></br>{`
`}{`2nd one is Olberic Defend x2, Thunder M, Rev Jam.`}<br parentName="p"></br>{`
`}{`3rd one is Merchants Sidestep (if both requires Leghold)`}<br parentName="p"></br>{`
`}{`You should choose the open based on T1 turn order.`}<br parentName="p"></br>{`
`}{`I'm not going to cover all scenarios here, but here's a `}<a parentName="p" {...{
          "href": "https://docs.google.com/spreadsheets/d/1vJeghl_L_KTCaCBNBJtCcZa2ocLllJrFX3aIvvXhKFQ/edit#gid=1078495202"
        }}>{`link`}</a>{` to my spreadsheet scribbles that goes over them.`}</p>
      <p parentName="blockquote">{`If you were paying attention, you might be wondering why we bought the Bottle of Blinding Dust`}<br parentName="p"></br>{`
`}{`It's for this fight! You can use it as a mega hailmary if you need the 6T to PB.`}<br parentName="p"></br>{`
`}{`Essentially, just skip the Sidesteps and throw the bottle with 1 of your free turns. And pray.`}</p>
    </blockquote>
    <p><strong parentName="p">{`6 Turn fight`}</strong></p>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Leghold`}</li>
      <li parentName="ul">{`Tressa: Lightning Blast / Olive`}</li>
      <li parentName="ul">{`Therion: Sidestep / Olive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Axe x3 `}{`[2R]`}</li>
      <li parentName="ul">{`Tressa: Sidestep`}</li>
      <li parentName="ul">{`Therion: Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchants: HHV x4`}</li>
      <li parentName="ul">{`Olberic: Revitalizing Jam Olberic`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-2"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Leghold`}</li>
      <li parentName="ul">{`Tressa: Pom L self`}</li>
      <li parentName="ul">{`Therion: Herb of Valor (fight becomes range) / Pom S self / Any M Stone`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Attack x4`}</li>
      <li parentName="ul">{`Tressa: HHB x3`}</li>
      <li parentName="ul">{`Therion: Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`HHVxMAX + L Stone`}</li>
    </ul>
    <p><strong parentName="p">{`9 Turn Fight`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`This fight isn't completely scripted, I'll be listing a rough script along with goals for each break.`}<br parentName="p"></br>{`
`}{`To heal Olberic a Grape M or Grape Bunch works.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`The big thing to look for is getting Therion 5BP before his action T4. T3 Therion last into T4 Therion 1st really sucks.`}<br parentName="p"></br>{`
`}{`You can delay T3 Leghold to T4 to guarantee it. That + 2BP on Tressa more or less guarantees win.`}</p>
      <p parentName="blockquote">{`Alternatively, you can look for Tressa 3BP T4 and Therion 2BP T4.`}<br parentName="p"></br>{`
`}{`Then you do Bandits & AC T4, and have them Pom/Jam themselves T5`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <p><em parentName="p">{`Break this turn, revive if needed, start setting up Sidesteps x2`}</em></p>
    <ul>
      <li parentName="ul">{`Olberic: Axe x3`}</li>
      <li parentName="ul">{`Tressa: Olive / Lightning Blast / Sidestep x2`}</li>
      <li parentName="ul">{`Therion: Olive / Sidestep x2`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If somehow you don't have enough turns, you can delay Leghold till T4`}<br parentName="p"></br>{`
`}{`You can do this on T6 as well`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Leghold / Pom/Jam Therion`}</li>
      <li parentName="ul">{`Tressa: Sidestep x2 / Pom L Therion / Heal Olberic`}</li>
      <li parentName="ul">{`Therion: Sidestep x2 / Pom L Therion / Heal Olberic`}</li>
    </ul>
    <p><em parentName="p">{`Weak: Axe, Wind, Light`}</em></p>
    <h5 {...{
      "id": "turn-4-3"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Pom/Jam Therion / Herb of Valor / Heal Self`}</li>
      <li parentName="ul">{`Tressa: Pom/Jam Therion / Herb of Valor / Heal Olberic / Pom Self if <2 BP`}</li>
      <li parentName="ul">{`Therion: Corrosive x3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Attack x3`}</li>
      <li parentName="ul">{`Merchant 1: HHB x4`}</li>
      <li parentName="ul">{`Merchant 2: Rev Jam / Pom L Merchant 1 (Ideally this is Therion)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6-1"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Heal Self / Leghold`}</li>
      <li parentName="ul">{`Merchants: HHVx4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Steal SP can miss, and you might not have a Thunder M, which is why it's nice to have BP on Therion here`}</p>
    </blockquote>
    <p><em parentName="p">{`Weak: Dagger, Lightning, Light`}</em></p>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Leghold / Pom Therion / Thunder M`}</li>
      <li parentName="ul">{`Tressa: Lightning Blast`}</li>
      <li parentName="ul">{`Therion: Steal SP (Can Dagger x4 if he has 5BP)`}</li>
    </ul>
    <p><em parentName="p">{`The amount of daggers you can do here is based off BP and whether or not you could throw an M Stone`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`If you threw a M, you can do one HHVx3`}</em></p>
    <h5 {...{
      "id": "turn-8"
    }}>{`Turn 8`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Pom Merchant / Thunder M / M Stone`}</li>
      <li parentName="ul">{`Tressa: Lightning Blast`}</li>
      <li parentName="ul">{`Therion: Dagger xAsManyAsYouCan / Steal SP`}</li>
    </ul>
    <h5 {...{
      "id": "turn-9"
    }}>{`Turn 9`}</h5>
    <ul>
      <li parentName="ul">{`HHVxMAX + L Stone`}</li>
    </ul>
    <p>{`End after cutscene w/ Erhardt.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      